// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseAccordionList_root__1kZEi","title":"BaseAccordionList_title__bpOxV","item":"BaseAccordionList_item__NbjBw"};